// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2AW5g","head":"ProcedureTableInfo_head__oxxdI"};